import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import BasicDialogStepper from '../../core/BasicDialogStepper';
import GroupPickerContainer from '../../core/GroupPickerContainer';
import LabelledSwitch from '../../core/LabelledSwitch';
import EnterProjectDetails from '../../core/project/EnterProjectDetails';
import MultiLanguageSelector from '../../core/project/MultiLanguageSelector';
import SelectDefaultLang from '../../core/project/SelectDefaultLang';
import { globalStyles } from '../../core/style/gstheme';
import TitledPanel from '../../core/TitledPanel';
import { DEFAULT_LANG } from '../../core/utils/constants';
import { sanitiseText } from '../../core/utils/utils';
import { ENTITLEMENTS } from '../../application-core/constants';

const styles = () => {
    return Object.assign({}, globalStyles);
};

const steps = ['Default Language', 'Project Detail', 'Additional Languages', 'SKOS-XL', 'User Groups'];

function EnableXL(props) {
    return (
        <TitledPanel title="SKOS-XL" height="full">
            <LabelledSwitch
                dataTest="skosXL"
                checked={props.skosXL || false}
                handleChange={props.onEnableXL}
                label="Enable" />
        </TitledPanel>
    );
}

class CreateVocabularyProject extends React.Component {

    state = {
        title: "",
        skosXL: false,
        viewEntitlement: false,
        description: "",
        projectLang: [],
        groups: [],
        defaultLang: DEFAULT_LANG
    };

    onSelectLang = (lang) => this.setState({ defaultLang: lang, projectLang: [] });

    onSelectAdditionalLang = (lang) => {
        let langProp = [...this.state.projectLang];
        if (langProp.includes(lang)) {
            langProp = langProp.filter(item => item !== lang);
        }
        else {
            langProp.push(lang);
        }
        this.setState({ projectLang: langProp });
    };

    onSetAdmin = () => this.setState({ viewEntitlement: true });

    onSelectGroup = (group, userGroups) => {
        let groupsProp = [...this.state.groups];
        if (groupsProp.includes(group)) {
            groupsProp = groupsProp.filter(item => item !== group);
        }
        else {
            groupsProp.push(group);
        }
        const viewEntitlement = groupsProp.some(gp =>
            userGroups.find(ug => ug.id === "https://graphifi.com/data/usergroup/admins")
            ||
            userGroups.find(ug => ug.id === gp).entitlement.includes(ENTITLEMENTS.VIEW_TAXONOMY_PROJECT));
        this.setState({ groups: groupsProp, viewEntitlement });
    };

    onEnableXL = (checked) => this.setState({ skosXL: checked });

    onTitleChange = (event) => {
        const cleanText = sanitiseText(event.target.value);
        this.setState({ title: cleanText });
    };

    onDescChange = (event) => {
        const cleanText = sanitiseText(event.target.value);
        this.setState({ description: cleanText });
    };

    getStepContent = (step) => {
        switch (step) {
            case 0:
                return <SelectDefaultLang
                    classes={this.props.classes}
                    lang={this.state.defaultLang}
                    onSelectLang={this.onSelectLang} />;
            case 1:
                return <EnterProjectDetails
                    classes={this.props.classes}
                    title={this.state.title}
                    mandatory={true}
                    lang={this.state.defaultLang}
                    description={this.state.description}
                    handleTitleChange={this.onTitleChange}
                    handleDescChange={this.onDescChange} />;
            case 2:
                return <MultiLanguageSelector classes={this.props.classes}
                    defaultLang={this.state.defaultLang} lang={this.state.projectLang} onSelectAdditionalLang={this.onSelectAdditionalLang} />;
            case 3:
                return <EnableXL classes={this.props.classes} skosXL={this.state.skosXL} onEnableXL={this.onEnableXL} />;
            case 4:
                return <GroupPickerContainer
                    groupList={this.state.groups}
                    onSetAdmin={this.onSetAdmin}
                    requiredViewEntitlement={ENTITLEMENTS.VIEW_TAXONOMY_PROJECT}
                    handleToggle={this.onSelectGroup}
                    adminIsEditable={false} />;
            default:
                return 'Unknown step';
        }
    };

    handleReset = () => {
        this.setState({
            title: "",
            skosXL: false,
            description: "",
            projectLang: [],
            groups: [],
            defaultLang: DEFAULT_LANG
        });
    };

    // There must be at least one group selected where user has project view entitlement
    isComplete = () => this.state.title && this.state.title.trim() !== "" && this.state.viewEntitlement;

    render() {

        return (
            <BasicDialogStepper
                height="360px"
                name="createNewProject"
                steps={steps}
                getStepContent={this.getStepContent}
                title="Create Project"
                isComplete={this.isComplete}
                onExitStepper={this.handleReset}
                onComplete={() => this.props.onComplete(this.state)} />
        );
    }
}

CreateVocabularyProject.propTypes = {
    onComplete: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(CreateVocabularyProject);